import { FormField, FieldType } from '../../types/formBuilder';

// Helper function to create a field from type
export function createFieldFromType(type: FieldType, t?: (key: string) => string, sectionId?: string): FormField {
  const baseField: FormField = {
    id: '',
    type,
    name: `${type}_${Date.now()}`,
    label: getDefaultLabel(type, t),
    required: false,
    width: 'full',
    order: 0,
    section: sectionId
  };

  // Add type-specific configurations
  switch (type) {
    case 'select':
    case 'multiselect':
    case 'radio':
    case 'checkbox':
      return {
        ...baseField,
        options: [
          { value: 'option1', label: 'Option 1' },
          { value: 'option2', label: 'Option 2' }
        ]
      };
    
    case 'number':
    case 'currency':
      return {
        ...baseField,
        config: {
          min: 0,
          step: 1
        }
      };
    
    case 'date':
      return {
        ...baseField,
        config: {
          format: 'YYYY-MM-DD'
        }
      };
    
    case 'file':
    case 'image':
      return {
        ...baseField,
        config: {
          maxSize: 5 * 1024 * 1024, // 5MB
          multiple: false
        }
      };
    
    case 'textarea':
      return {
        ...baseField,
        config: {
          maxLength: 1000
        }
      };
    
    case 'rating':
      return {
        ...baseField,
        config: {
          max: 5
        }
      };
    
    default:
      return baseField;
  }
}

// Helper function to get default label with translations
export function getDefaultLabel(type: FieldType, t?: (key: string) => string): string {
  if (!t) {
    // Fallback to English if no translation function provided
    const labels: Record<FieldType, string> = {
      text: 'Text Field',
      email: 'Email Address',
      phone: 'Phone Number',
      number: 'Number',
      currency: 'Amount',
      percentage: 'Percentage',
      date: 'Date',
      datetime: 'Date & Time',
      time: 'Time',
      textarea: 'Description',
      select: 'Select Option',
      multiselect: 'Select Multiple',
      radio: 'Choose One',
      checkbox: 'Select All That Apply',
      switch: 'Enable/Disable',
      file: 'Upload File',
      image: 'Upload Image',
      color: 'Choose Color',
      range: 'Select Range',
      rating: 'Rate This',
      signature: 'Signature',
      address: 'Address',
      customer_lookup: 'Select Customer',
      product_lookup: 'Select Product',
      user_lookup: 'Select User',
      organization_lookup: 'Select Organization',
      custom_object: 'Custom Object'
    };
    return labels[type] || 'Field';
  }

  // Use translations
  return t(`formBuilder.fieldTypes.${type}`) || t('formBuilder.fieldTypes.text') || 'Field';
}
